import { useEffect, useMemo, useState } from "react";
import { Row, Col, Container, Card, CardBody } from "reactstrap";
import { useParams } from "react-router-dom";
import Loader from "react-loaders";

import { useDispatch } from "react-redux";
import { viewPromoCode } from "../../redux/services/promocodeServices";

const ReferralDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [codeData, setCodeData] = useState();

  const getCodeDetails = async (id) => {
    await viewPromoCode(id).then((res) => {
      setCodeData(res?.data);
    });
  };
  useEffect(() => {
    if (id) {
      getCodeDetails(id);
    }
  }, [dispatch, id]);

  return (
    <div>
      {codeData ? (
        <div>
          <Row>
            <Col md="12" className="mt-1 mb-4">
              <Card>
                <CardBody>
                  <h2 className="border-bottom mb-2 pb-2">
                    Promo Code Details
                  </h2>
                  <div className="p-4 row">
                    <h6 className="col-4">
                      <strong>Name</strong>{" "}
                      <p className="my-3">{codeData?.name || "N/A"}</p>
                    </h6>
                    <h6 className="col-4">
                      <strong>Description</strong>{" "}
                      <p className="my-3">{codeData?.description || "N/A"}</p>
                    </h6>
                    <h6 className="col-4">
                      <strong>Emails</strong>{" "}
                      <p className="my-3">{codeData?.emails || "N/A"}</p>
                    </h6>

                    <h6 className="col-4">
                      <strong>Start Date</strong>{" "}
                      <p className="my-3">{codeData?.startDate || "N/A"}</p>
                    </h6>
                    <h6 className="col-4">
                      <strong>End Date</strong>{" "}
                      <p className="my-3">{codeData?.endDate || "N/A"}</p>
                    </h6>
                    <h6 className="col-4">
                      <strong>Used By</strong>{" "}
                      <p className="my-3">
                        {codeData?.usedBy == 1 ? "Company" : "Talent" || "N/A"}
                      </p>
                    </h6>
                    <h6 className="col-4">
                      <strong>Used Count</strong>{" "}
                      <p className="my-3">{codeData?.usedCount || "N/A"}</p>
                    </h6>
                    {codeData?.isAdditionalDays && (
                      <h6 className="col-4">
                        <strong>Additional Dayes</strong>{" "}
                        <p className="my-3">
                          {codeData?.additionalDays || "N/A"}
                        </p>
                      </h6>
                    )}
                    {codeData?.isDiscount && (
                      <h6 className="col-4">
                        <strong>Discount</strong>{" "}
                        <p className="my-3">
                          {`${codeData?.discountNum}%` || "N/A"}
                        </p>
                      </h6>
                    )}
                    <h6 className="col-4">
                      <strong>Plans</strong>{" "}
                      {codeData?.plans?.map((plan) => {
                        return (
                          <p className="my-3">{`${plan?.title}` || "N/A"}</p>
                        );
                      })}
                    </h6>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <div
          className="loader-container"
          style={{ width: "75vw", height: "75vh" }}
        >
          <div className="loader-container-inner">
            <div className="text-center">
              <Loader type="ball-pulse-rise" />
            </div>
            <h6 className="mt-5">Please wait...</h6>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferralDetails;
